import React from 'react'
import {connect} from 'react-redux';
import Select from 'react-select';
import {Field, reduxForm} from 'redux-form';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import '../../css/impressao-lista-passageiro.css';
import qs from 'qs';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getOperadorEmpresa,
    getGestorOperacoes,
    getPerfisVendedores,
    getVendedorAgencia,    
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao, { validaPerfis, podeImprimirBilheteAposEmbarque } from '../../security/Autorizacao';
import Titulo from '../comum/Titulo';
import {buscarReservasItinerario} from '../../actions/reserva/buscarReservasItinerario';
import buscarItinerario from '../../actions/itinerario/buscarItinerario';
import embarcarPassageiro from '../../actions/reserva/embarcarPassageiro';
import desembarcarPassageiro from '../../actions/reserva/desembarcarPassageiro';
import {showSuccessMsg} from '../../util/messagesUtil';
import limparReservasItinerario from '../../actions/reserva/limparReservasItinerario';
import { EMPRESA_POLITUR, listaTipoPrecos, tipoCategoria, tipoImpressaoCupom } from '../../util/constantsUtil';
import selecionarTrechoPassageiro from '../../actions/itinerario/selecionarTrechoPassageiro';
import buscarTrechosReservasItinerario from '../../actions/reserva/buscarTrechosReservasItinerario';
import limparTrechosReservasItinerario from '../../actions/reserva/limparTrechosReservasItinerario';
import { renderFieldCheck } from '../../util/inputs';
import ReciboReservaPassageiro from './ReciboReservaPassageiro';
import ModalImpressaoCupomReservaPassageiro from './ModalImpressaoCupomReservaPassageiro';
import buscarPedido from '../../actions/pedido/buscarPedido'
import selecionarPedido from '../../actions/pedido/selecionarPedido';
import naoEmbarcarPassageiro from '../../actions/reserva/naoEmbarcarPassageiro';
import verificaVinculoItinerarioEMotorista from '../../actions/itinerario/verificaVinculoItinerarioEMotorista';
import ModalImpressaoListaPassageiro from './ModalImpressaoListaPassageiro';


const ModalConfirmacaoEmbarqueDesembarque = ({acao, reserva}) => (
    <div className="modal fade" id="modalConfirmarEmbarqueDesembarque" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmarEmbarqueDesembarque" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content vx-modal-content">
                <div className="vx-modal-header">
                    <div className="vx-modal-header-left">
                        <i className="material-icons">people</i>
                        <span className="vx-modal-title">{reserva.dataHoraEmbarque ? 'Confirmar Desembarque' : 'Confirmar Embarque'}</span>
                    </div>
                </div>
                <div className="vx-modal-body">
                    {reserva.dataHoraEmbarque ? <p>Confirmar o desembarque do
                            passageiro <strong>{reserva.passageiroDto ? reserva.passageiroDto.nome : ''}?</strong></p>
                        : <p>Confirmar o embarque do
                            passageiro <strong>{reserva.passageiroDto ? reserva.passageiroDto.nome : ''}?</strong></p>}
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" className="vx-btn-primary" data-dismiss="modal"
                            onClick={() => acao(reserva)}>Sim
                    </button>
                </div>
            </div>
        </div>
    </div>);

const ModalConfirmacaoOperacaoNaoEmbarque = ({ reserva, naoEmbarcar, limpar }) => { return (
    <div className="modal fade" id="modalConfirmacaoOperacaoNaoEmbarque" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacaoOperacaoNaoEmbarque" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content vx-modal-content">
          <div className="vx-modal-header">
            <div className="vx-modal-header-left">
              <i className="material-icons">block</i>
              <span className="vx-modal-title">Confirmar Não Embarque</span>
            </div>
          </div>
          <div className="vx-modal-body">
            <p>Confirmar o não embarque do passageiro <strong>{reserva.passageiroDto && reserva.passageiroDto.nome}</strong></p>
          </div>
          <div className="vx-modal-footer">
            <button type="button" className="vx-btn-secondary"
                    data-dismiss="modal" onClick={()=> limpar()}>Cancelar
            </button>
            <button type="button" className="vx-btn-primary" data-dismiss="modal"
                    onClick={() => naoEmbarcar()}>Sim
            </button>
          </div>
        </div>
      </div>
    </div>)};

export class PainelPassageirosItinerario extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reservaSelecionada: '',
            retorno: '/painel-itinerarios',
            ordernarTrecho: false,
            reservaSelecionadaImpressao: null,
            pagina: null,
            isOpenModal: false,
            tipoImpressaoCupom: tipoImpressaoCupom.normal,
            refComponent: React.createRef(),
        }

        this.componentRef = React.createRef();
    }

    componentDidMount() {
        this.props.limparReservasItinerario();
        this.props.limparTrechosReservasItinerario();
        this.props.selecionarTrechoPassageiro(null);
        this.setState({pagina: window})
        const parametros = qs.parse(this.props.history.location.search, {ignoreQueryPrefix: true});
        if ((this.props.empresaSelecionada.id === EMPRESA_POLITUR && this.ehPerfilVendedor()) || this.props.empresaSelecionada.habilitadoBloqueioListaPassageiro) {
            this.props.history.push('/painel-itinerarios');
            return;
        }
        if (parametros.tipo == 'embarque') {
            this.setState({retorno: '/painel-embarque-passageiros'})
        }
        if (parametros.itinerario) {
            this.props.buscarItinerario(this.props.empresaSelecionada.id, parametros.itinerario)
            this.props.buscarTrechosReservasItinerario(parametros.itinerario, this.props.empresaSelecionada.id)
            this.props.buscarReservasItinerario(parametros.itinerario, this.props.empresaSelecionada.id, null, null, false);
            this.props.verificaVinculoItinerarioEMotorista(parametros.itinerario, this.props.empresaSelecionada.id);            
        } else {
            this.props.history.push('/painel-itinerarios');
        }
    }

    ehPerfilVendedor() {
        return validaPerfis([getVendedorAgencia(this.props.empresaSelecionada.id)])
    }

    exibirCamposBusca() {
        return <div className="col-12 col-sm-12 col-md-12 mt-2 mb-4" id='printPageButton'>
            <div className='row'>
                <div className='col-10 col-sm-10 col-md-8'>
                    <label>Trechos</label>
                    <Field name='trechos' component={this.exibirComboTrechos.bind(this)}/>
                </div>
            </div>
        </div>
    }

    exibirComboTrechos(event) {
        if (this.props.trechosReservasItinerario && this.props.trechosReservasItinerario.length) {
            return (
                <div>
                    <Select
                        {...event.input}
                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                        placeholder='Selecione uma trecho...'
                        options={this.props.trechosReservasItinerario.map(elemento => ({
                            label: elemento.descricao,
                            value: elemento.uuid,
                        }))}
                        onChange={value => this.selecionarTrecho(value)}
                        value={this.props.trechoSelecionado.value ? this.props.trechoSelecionado : null}
                        isClearable={true}
                    />
                    {event.meta.touched
                    && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
                </div>
            )
        }
        return '';
    }

    selecionarTrecho(trecho) {        
        if (trecho && trecho.value) {
            const trechoSelecionado = this.props.trechosReservasItinerario.find(it => it.uuid === trecho.value)
            if (trechoSelecionado) {
                this.props.selecionarTrechoPassageiro(trecho);                
                this.props.buscarReservasItinerario(this.props.itinerarioSelecionado.id, this.props.empresaSelecionada.id, trechoSelecionado.idTrechoOrigem, trechoSelecionado.idTrechoDestino, this.state.ordernarTrecho);
            }
        } else {
            this.props.selecionarTrechoPassageiro(null);            
            this.props.buscarReservasItinerario(this.props.itinerarioSelecionado.id, this.props.empresaSelecionada.id, null, null, this.state.ordernarTrecho);
        }
    }

    buscarReservasItinerario(ehParam, checked) {
        if (this.props.trechoSelecionado.value) {
            const trechoSelecionado = this.props.trechosReservasItinerario.find(it => it.uuid === this.props.trechoSelecionado.value)
            this.props.buscarReservasItinerario(this.props.itinerarioSelecionado.id, this.props.empresaSelecionada.id, trechoSelecionado.idTrechoOrigem, trechoSelecionado.idTrechoDestino, ehParam ? checked : this.state.ordernarTrecho);
        } else {
            this.props.buscarReservasItinerario(this.props.itinerarioSelecionado.id, this.props.empresaSelecionada.id, null, null, ehParam ? checked : this.state.ordernarTrecho);
        }
    }

    exibir() {
        if (this.props.reservas && this.props.reservas.length) {
            return <React.Fragment>
                <table id="lista-passageiros" className="table-responsive table table-striped table-bordered" data-show-print={true}>
                    <thead>
                    <tr>
                        <td colSpan={14} className='text-center'><strong>{this.props.empresaSelecionada.nome}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}><strong>Prefixo:</strong> {this.props.itinerarioSelecionado.rotaDto.prefixo}
                        </td>
                        <td colSpan={8}>
                            <strong>Veículo:</strong> {this.props.itinerarioSelecionado.veiculoDto.descricao}</td>
                        <td colSpan={3}><strong>Total de
                            passageiros:</strong> {this.props.reservas.length}</td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                            <strong>Origem:</strong> {`${this.props.itinerarioSelecionado.rotaDto.cidadeOrigem.nome} (${this.props.itinerarioSelecionado.rotaDto.cidadeOrigem.uf}) - ${this.props.itinerarioSelecionado.dataHoraPartida}`}
                        </td>
                        <td colSpan={4}>
                            <strong>Destino:</strong> {`${this.props.itinerarioSelecionado.rotaDto.cidadeDestino.nome} (${this.props.itinerarioSelecionado.rotaDto.cidadeDestino.uf}) - ${this.props.itinerarioSelecionado.dataHoraChegada}`}
                        </td>                        
                        <td colSpan={3}>
                            <strong>ID Rota:</strong> {this.props.itinerarioSelecionado.rotaDto.id}
                        </td>
                        <td colSpan={3}>
                            <strong>ID Itinerário:</strong> {this.props.itinerarioSelecionado.id}
                        </td>
                    </tr>
                    {this.props.itinerarioSelecionado.prestador ?
                    <tr>
                        <td colSpan={14}>
                            <strong>Prestador: </strong>{this.props.itinerarioSelecionado.prestador.valor}
                        </td>
                    </tr>: ''}
                    <tr>
                        <Autorizacao perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id),
                            getGestorEmpresa(this.props.empresaSelecionada.id),
                            getGestorOperacoes(this.props.empresaSelecionada.id),
                            getMotoristaEmpresa(this.props.empresaSelecionada.id),
                            getAdminEmpresa(this.props.empresaSelecionada.id),
                            getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                            <th id='printPageButton' scope="col"/>
                        </Autorizacao>
                        <th scope="col">Poltrona</th>                        
                        <th scope="col">Pedido</th>                        
                        <th scope="col">Nome</th>
                        <th scope="col">Verificador</th>
                        <th scope="col">Documento</th>                        
                        <th scope="col">Trecho</th>
                        <th scope='col'>Telefone</th>                        
                        <th scope="col">Tipo de passagem</th>
                        {this.ehItinerarioMisto(this.props.itinerarioSelecionado) ? <th scope="col">Categoria</th> : ''}
                        <th scope="col">Ponto de Embarque</th>
                        <th scope="col">Vendedor</th>
                        <th scope="col">Data/Hora embarque</th>
                        <th scope="col">Data/Hora desembarque</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.exibirCorpoTabela()}
                    </tbody>
                </table>
            </React.Fragment>
        }
        return <div className="vx-gp-empty">Itinerário não possui passagens vendidas</div>
    }

    exibirTabelaResumida() {
        if (this.props.reservas && this.props.reservas.length) {
            return <React.Fragment>
                <table id="lista-passageiros" className="table-responsive table table-striped table-bordered" data-show-print={true}>
                    <thead>
                    <tr>
                        <td colSpan={14} className='text-center'><strong>{this.props.empresaSelecionada.nome}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}><strong>Prefixo:</strong> {this.props.itinerarioSelecionado.rotaDto.prefixo}
                        </td>
                        <td colSpan={8}>
                            <strong>Veículo:</strong> {this.props.itinerarioSelecionado.veiculoDto.descricao}</td>
                        <td colSpan={3}><strong>Total de
                            passageiros:</strong> {this.props.reservas.length}</td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                            <strong>Origem:</strong> {`${this.props.itinerarioSelecionado.rotaDto.cidadeOrigem.nome} (${this.props.itinerarioSelecionado.rotaDto.cidadeOrigem.uf}) - ${this.props.itinerarioSelecionado.dataHoraPartida}`}
                        </td>
                        <td colSpan={4}>
                            <strong>Destino:</strong> {`${this.props.itinerarioSelecionado.rotaDto.cidadeDestino.nome} (${this.props.itinerarioSelecionado.rotaDto.cidadeDestino.uf}) - ${this.props.itinerarioSelecionado.dataHoraChegada}`}
                        </td>                        
                        <td colSpan={3}>
                            <strong>ID Rota:</strong> {this.props.itinerarioSelecionado.rotaDto.id}
                        </td>
                        <td colSpan={3}>
                            <strong>ID Itinerário:</strong> {this.props.itinerarioSelecionado.id}
                        </td>
                    </tr>
                    {this.props.itinerarioSelecionado.prestador ?
                    <tr>
                        <td colSpan={14}>
                            <strong>Prestador: </strong>{this.props.itinerarioSelecionado.prestador.valor}
                        </td>
                    </tr>: ''}
                    <tr>
                        <Autorizacao perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id),
                            getGestorEmpresa(this.props.empresaSelecionada.id),
                            getMotoristaEmpresa(this.props.empresaSelecionada.id),
                            getGestorOperacoes(this.props.empresaSelecionada.id),
                            getAdminEmpresa(this.props.empresaSelecionada.id),
                            getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                            <th id='printPageButton' scope="col"/>
                        </Autorizacao>
                        <th scope="col">Poltrona</th>                        
                        <th scope="col">Pedido</th>                        
                        <th scope="col">Nome</th>
                        <th scope="col">Verificador</th>
                        <th scope="col">Documento</th>                        
                        <th scope="col">Trecho</th>
                        <th colSpan={2} scope='col'>Telefone</th>                                                
                        {this.ehItinerarioMisto(this.props.itinerarioSelecionado) ? <th scope="col">Categoria</th> : ''}
                        <th scope="col">Ponto de Embarque</th>
                        <th colSpan={3} scope="col">Vendedor</th>                        
                    </tr>
                    </thead>
                    <tbody>
                    {this.exibirCorpoTabela()}
                    </tbody>
                </table>
            </React.Fragment>
        }
        return <div className="vx-gp-empty">Itinerário não possui passagens vendidas</div>
    }

    limparPedidoSelecionado() {
        this.props.selecionarPedido(null);
    }

    limparReservaSelecionada() {
        this.setState({reservaSelecionada: '', reservaSelecionadaImpressao: null})
    }

    selecionarReserva(reserva) {
        this.setState({reservaSelecionada: reserva})
    }

    selecionarReservaImpressao(reserva) {
        this.setState({reservaSelecionadaImpressao: reserva});
    }

    embarcarDesembarcar(reserva) {
        if (reserva.dataHoraEmbarque) {
            this.props.desembarcarPassageiro(this.props.empresaSelecionada.id, reserva.id).then(() => {
                showSuccessMsg('Embarque de passageiro cancelado com sucesso!');                
                this.buscarReservasItinerario();
            })
        } else {
            this.props.embarcarPassageiro(this.props.empresaSelecionada.id, reserva.id).then(() => {
                showSuccessMsg('Embarque de passageiro realizado com sucesso!');
                this.buscarReservasItinerario();
            })
        }
    }

    exibirBotaoEmbarqueDesembarque(reserva) {
        if (reserva.dataHoraEmbarque && !reserva.dataHoraDesembarque) {
            return <button type="submit" style={{fontSize: 10}} data-toggle="modal"
                           data-target="#modalConfirmarEmbarqueDesembarque" className="btn btn-sm btn-vermelho"
                           onClick={() => this.selecionarReserva(reserva)}>Desembarcar</button>
        }
        if (!reserva.dataHoraEmbarque) {
            return <button type="submit" style={{fontSize: 10}} data-toggle="modal"
                           data-target="#modalConfirmarEmbarqueDesembarque" className="btn btn-sm btn-verde"
                           onClick={() => this.selecionarReserva(reserva)}>Embarcar</button>
        }
    }

    exibirBotaoImprimir(reserva) {
        if (!reserva.dataHoraEmbarque || podeImprimirBilheteAposEmbarque(this.props.empresaSelecionada.id)) {
            return (            
                <button style={{fontSize: 10}} className="btn btn-sm btn-laranja" data-toggle="modal" 
                    data-target="#modalImpressaoCupomReservaPassageiro"
                    onClick={() => {
                        this.props.buscarPedido(reserva.pedidoId, this.props.empresaSelecionada.id)
                            .then(() => {                                
                                const reservaPedido = this.props.pedido.reservas.find(it => it.id === reserva.id)
                                this.selecionarReservaImpressao(reservaPedido)
                            })
                    }}>Imprimir
                </button>
            )
        }
    }

    exibirBotaoNaoEmbarque(reserva) {
        if (!reserva.dataHoraEmbarque) {
            return (<button style={{fontSize: 10}} className="btn btn-sm btn-amarelo" data-toggle="modal"
                data-target="#modalConfirmacaoOperacaoNaoEmbarque"
                onClick={() => {
                    this.selecionarReserva(reserva)
                }}
            >Não_Embarque
            </button>)
        }
    }

    naoEmbarcar() {
        if (!this.state.reservaSelecionada.dataHoraEmbarque) {
            this.props.naoEmbarcarPassageiro(this.props.empresaSelecionada.id, this.state.reservaSelecionada.id).then(() => {
                showSuccessMsg('O Passageiro foi não embarcado com sucesso!');
                this.buscarReservasItinerario();
            })
        }

    }

    tipoDocumentoEhPassaporteOuOutros(passageiro) {
        return passageiro.tipoDocumento == 'PASSAPORTE' || passageiro.tipoDocumento == 'OUTROS'
    }

    retornaTipoPrecoPoltrona(numeroPoltrona) {
        let valor = ''        
        const poltronas = this.props.itinerarioSelecionado.poltronas;
        if (poltronas.length > 0) {
            poltronas.forEach(it => {
                if (it && it.numero) {                    
                    if (it.numero == numeroPoltrona) {
                        const item = listaTipoPrecos.filter(l => l.id == it.tipoPreco)                        
                        valor = item[0].descricao;                        
                    }                    
                }    
            });            
        }

        return valor
    }

    exibirCorpoTabela() {
        const valida = (validaPerfis([getOperadorEmpresa(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getGestorOperacoes(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFiscalEmbarque(this.props.empresaSelecionada.id)]) ||  this.props.temVinculoItinerarioEMotorista);

        return this.props.reservas.map(reserva => <tr key={reserva.id}>
            {valida ?
                <td id='printPageButton'>{this.exibirBotaoEmbarqueDesembarque(reserva)}
                    <div className='d-flex mt-2'>{this.exibirBotaoImprimir(reserva)}</div>
                    <div className='d-flex mt-2'>{this.exibirBotaoNaoEmbarque(reserva)}</div>
                </td>: <td></td>}
            <th scope="row">{reserva.numeroPoltrona}</th>            
            <td>{reserva.pedidoId}</td>
            
            <td>
                <div>{capitalizarTodasPrimeirasLetras(reserva.passageiroDto.nome)}</div>
                {reserva.passageiroDto.criancaDto ? <div>
                    <strong>Criança: </strong>{capitalizarTodasPrimeirasLetras(reserva.passageiroDto.criancaDto.nome)}
                </div> : ''}
            </td>
            <td>{this.tipoDocumentoEhPassaporteOuOutros(reserva.passageiroDto) ? reserva.passageiroDto.documentoComFoto : reserva.passageiroDto.cpfPassageiro}</td>
            <td>{reserva.passageiroDto.documentoComFoto}</td>            
            <td>{`${reserva.descCidadeOrigemAlternativa || reserva.descCidadeOrigem} -> ${reserva.descCidadeDestinoAlternativa || reserva.descCidadeDestino}`}</td>
            {this.aprensetarTipoNormal() ? <td>{reserva.passageiroDto.telefone ?  `${reserva.passageiroDto.ddi} ${reserva.passageiroDto.telefone}` : 'Não informado'}</td> :
                <td colSpan={2}>{reserva.passageiroDto.telefone ?  `${reserva.passageiroDto.ddi} ${reserva.passageiroDto.telefone}` : 'Não informado'}</td>}
            {this.aprensetarTipoNormal() ? <td>{reserva.passageiroDto.descTipoEmissao}</td> : ''}
            {this.ehItinerarioMisto(this.props.itinerarioSelecionado) ? <td scope="row">{this.retornaTipoPrecoPoltrona(reserva.numeroPoltrona)}</td> : ''}
            <td>{reserva.embarque}</td>
            {this.aprensetarTipoNormal() ? <td>{reserva.nomeVendedor}</td> : <td colSpan={3}>{reserva.nomeVendedor}</td>}
            {this.aprensetarTipoNormal() ? <>
                <td>{reserva.dataHoraEmbarque ? `${reserva.dataHoraEmbarque}-${reserva.nomeResponsavelEmbarque}` : 'Não embarcado'}</td>
                <td>{reserva.dataHoraDesembarque ? `${reserva.dataHoraDesembarque}-${reserva.nomeResponsavelDesembarque}` : 'Não desembarcado'}</td>
            </>
            :''}

        </tr>)
    }

    imprimir() {
        window.print();
    }

    funOrdernarTrecho(e) {        
        this.setState({ ordernarTrecho: e.target.checked})
        this.buscarReservasItinerario(true, e.target.checked)
    }

    exibirImpimir() {
        return (
            <>
                <div className="col-12 col-sm-12 col-md-12" id='printPageButton'>
                    <Field type="checkbox" name='ordernaPortrecho' component={renderFieldCheck}
                        label="Ordern por Trecho: "
                        css="form-check-input" readOnly={false}
                        onChange={(e => this.funOrdernarTrecho(e))}
                        />                                
                </div>                
                <div className="area-botoes-download text-center text-sm-right text-md-right text-lg-right mb-4"
                    id='printPageButton'>
                    <button data-toggle="modal" data-target="#modalImpressaoListaPassageiro"
                        className="vx-btn-primary ml-2"
                        onClick={() => this.habilitarDesabilitarReciboCupomEncomenda(true)}>
                        <i className="material-icons mr-1" style={{ fontSize: '16px', verticalAlign: 'middle' }}>print</i>
                        Imprimir
                    </button>
                </div>
            </>
        )
    }

    ehItinerarioMisto(itinerario) {
        return itinerario.tipoCategoria && tipoCategoria.mista.valor == itinerario.tipoCategoria;
    }

    setTipoImpressaoCupom(tipo) {
        this.setState({tipoImpressaoCupom: tipo})
    }

    habilitarDesabilitarReciboCupomEncomenda(valor) {
        this.setState({isOpenModal: valor})
    }

    aprensetarTipoNormal() {
        return this.state.tipoImpressaoCupom == tipoImpressaoCupom.normal
    }

    exibirListaTabela() {
        if (this.state.tipoImpressaoCupom === tipoImpressaoCupom.livre) {
            return <div className="impressao-livre">{this.exibir()}</div>;
        }
        if (this.aprensetarTipoNormal()) {
            return this.exibir();
        }
        return this.exibirTabelaResumida();
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getMotoristaEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <h1 className='printer-element col-12 text-center mb-4' id='printPageButton'>LISTA DE PASSAGEIROS</h1>
                <div className="container-padrao" id='table-responsive'>
                    <Titulo texto="Lista de passageiros" urlRetorno={this.state.retorno}/>
                    {this.exibirCamposBusca()}
                    {this.exibirImpimir()}
                    {this.exibirListaTabela()}
                    <ModalConfirmacaoEmbarqueDesembarque reserva={this.state.reservaSelecionada}
                                                         acao={this.embarcarDesembarcar.bind(this)}/>
                    <ModalImpressaoCupomReservaPassageiro
                        componentRef={this.componentRef}
                        reservaSelecionada={this.state.reservaSelecionadaImpressao}
                        pedido={this.props.pedido}
                        limparReservaSelecionada={this.limparReservaSelecionada.bind(this)}
                        limparPedidoSelecionado={this.limparPedidoSelecionado.bind(this)} />
                    <ReciboReservaPassageiro componentRef={this.componentRef} reservaSelecionada={this.state.reservaSelecionadaImpressao} empresaSelecionada={this.props.empresaSelecionada} pedido={this.props.pedido} />
                    <ModalConfirmacaoOperacaoNaoEmbarque reserva={this.state.reservaSelecionada}
                        naoEmbarcar={this.naoEmbarcar.bind(this)}
                        limpar={this.limparReservaSelecionada.bind(this)} />
                    <ModalImpressaoListaPassageiro
                        pagina={this.state.pagina}
                        isOpenModal={this.state.isOpenModal}
                        tipo={this.state.tipoImpressaoCupom}
                        setTipoImpressaoCupom={this.setTipoImpressaoCupom.bind(this)}
                        habilitarDesabilitarReciboCupomEncomenda={this.habilitarDesabilitarReciboCupomEncomenda.bind(this)}
                    />
                </div>
            </Autorizacao>
        );
    }
}

export function mapStateToProps(state) {
    return {
        reservas: state.reservas,
        itinerarioSelecionado: state.itinerarioSelecionado,
        empresaSelecionada: state.empresaSelecionada,
        trechoSelecionado: state.trechoPassageiroSelecionado,
        trechosReservasItinerario: state.trechosReservasItinerario,
        pedido: state.pedido,
        temVinculoItinerarioEMotorista: state.temVinculoItinerarioEMotorista
    }
}


export default connect(mapStateToProps, {
    buscarItinerario,
    buscarReservasItinerario,
    embarcarPassageiro,
    desembarcarPassageiro,
    limparReservasItinerario,
    selecionarTrechoPassageiro,
    buscarTrechosReservasItinerario,
    limparTrechosReservasItinerario,
    buscarPedido,
    selecionarPedido,
    naoEmbarcarPassageiro,
    verificaVinculoItinerarioEMotorista
})(reduxForm({
    form: 'formularioConsultaTrechosPassageiros'
})(PainelPassageirosItinerario));